<template>
<div>
  <v-row class="mb-2">
    <v-col cols="12" sm="6" md="8" lg="9">
    <h2 class="subheading green--text">My Requests</h2>
  </v-col>
  <v-col cols="12" sm="6" md="4" lg="3" class="d-flex justify-center justify-sm-end">
    <v-btn @click="createRequest()" color="header" class="white--text">
      <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
      Create a Request
    </v-btn>
  </v-col>
  </v-row>
  <v-card v-if="pendingList.length > 0" class="mb-7">
  <v-data-table
    :headers="headers"
    :items="pendingList"
    :options.sync="options"
    :server-items-length="totalCount"
    :loading="loading"
    :footer-props="footerProps"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
      flat dense>
      <h2 class="mei-title mt-5 mb-1">Pending Requests</h2>
      </v-toolbar>
      <v-toolbar
        flat
      >
        <v-text-field
        v-model="searchText"
        append-icon="mdi-magnify"
        label="Search"
        color="green darken-2"
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            RequestCode: { title: 'Request Code' },
            RequestType: { title: 'Request Type' },
            DateCreated: { title: 'Date Created' },
            StatusText: { title: 'Status' },
            DateApproved: { title: 'Date Approved' },
            DateCreated: { title: 'Date Created' },
            }"
          csv-title="Pending Requests">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
      </v-toolbar>
    </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
          {{formatDateTime(item.DateCreated)}}
      </template>
      <template v-slot:[`item.Status`]="{ item }">
          <v-chip small v-if="item.StatusID == 10" color="grey"><v-icon small class="mr-1">mdi-timer</v-icon> For Approval</v-chip>
          <v-chip small dark v-if="item.StatusID == 7" color="header"><v-icon small class="mr-1">mdi-check-circle</v-icon>Approved & For Action</v-chip>
          <v-chip small v-if="item.IsCancelled == 1" color="red"><v-icon small class="mr-1">mdi-times-circle</v-icon>Cancelled</v-chip>
      </template>
      <template v-slot:[`item.DateApproved`]="{ item }">
          <span v-if="item.DateApproved">{{formatDateTime(item.DateApproved)}}</span>
          <i v-else>Not yet approved</i>
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn color="blue darken-2" class="white--text mr-2" outlined x-small @click="viewItem(item)">
          view
          </v-btn>
          <v-btn color="red darken-2" class="white--text mr-2" outlined x-small @click="print(item)">
          print
          </v-btn>
        </span>
      </template>
  </v-data-table>
   </v-card>

   <v-card v-else class="mb-7">
      <h2 class="mei-pending-title text-center py-5">No Pending Requests</h2>
   </v-card>

  <MyCompletedRequests />

   <v-dialog
          v-model="requestDialog"
          persistent
          max-width="900px"
          scrollable
        >
          <v-card>
            <v-card-title>
              <span>Create a Request</span>
              <v-spacer></v-spacer>
              <v-btn
                    icon
                    dark
                    color="secondary2"
                    @click="cancel()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
            </v-card-title>
            <v-card-text style="max-height: 900px;">
              <v-form @submit.prevent ref="formRef">
              <v-container>
              <v-row>
                <v-col cols="12">
                  <v-card
                    color="grey lighten-3"
                    flat
                  >
                  <v-card-text class="pa-0 ma-0">
                    <v-autocomplete
                    v-model="formData.RequestType"
                    @change="changeRequest()"
                    item-text="Description"
                    item-value="RequestTypeID"
                    :items="requestTypes"
                    outlined
                    hide-details
                    color="header"
                    label="Type of Request"
                    ></v-autocomplete>
                  </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row class="mt-0" v-if="formData.RequestType == 1">
                 <v-col cols="12" md="6">
                  <div class="d-flex align-center">
                    <v-checkbox
                      v-model="formData.UsePPMP"
                      hide-details
                      class="mr-2 mb-3 pt-0"
                      color="header"
                      label="Include PPMP Budget Code"
                    ></v-checkbox>
                  </div>

                    <v-autocomplete
                      v-if="formData.UsePPMP"
                      v-model="formData.PPMPBudgetCode"
                      @change="changeBudgetCode()"
                      outlined
                      dense
                      color="header"
                      label="PPMP Budget Code"
                      :items="budgetList"
                      item-text="BudgetCode"
                      item-value="PPMPIDs"
                      :rules="[formRules.required]"
                      hide-details
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else
                      outlined
                      dense
                      color="header"
                      label="PPMP Budget Code"
                      :disabled="true"
                      hide-details
                    ></v-autocomplete>

                <v-card outlined flat class="pa-3 mt-2" v-if="formData.PPMPBudgetCode">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <div class="text-subtitle-3">
                        Select PPMP Type you want unpublish:
                      </div>
                    </v-col>
                    <v-col cols="6">
                    <v-checkbox
                      v-model="formData.PPMPType"
                      label="LIB"
                      value="LIB"
                      color="header"
                      class="ma-0 pa-0"
                      :disabled="!formData.UsePPMP || hasPPMPStatus('LIB') != 'Published'"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="formData.PPMPType"
                      label="DBM"
                      value="DBM"
                      color="header"
                      class="ma-0 pa-0"
                      :disabled="!formData.UsePPMP || hasPPMPStatus('DBM') != 'Published'"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="formData.PPMPType"
                      label="NON-DBM"
                      value="NON-DBM"
                      color="header"
                      class="ma-0 pa-0"
                      :disabled="!formData.UsePPMP || hasPPMPStatus('NON-DBM') != 'Published'"
                      hide-details
                    ></v-checkbox>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-center">
                    <div>
                    <div>
                     <v-chip
                      x-small
                      :color="hasPPMPStatus('LIB') == 'Published' ? 'header' : 'warning'"
                      text-color="white"
                      v-if="formData.PPMPBudgetCode"
                    >
                      {{hasPPMPStatus('LIB')}}
                    </v-chip>
                    </div>

                    <div>
                     <v-chip
                      x-small
                      :color="hasPPMPStatus('DBM') == 'Published' ? 'header' : 'warning'"
                      text-color="white"
                      v-if="formData.PPMPBudgetCode"
                    >
                      {{hasPPMPStatus('DBM')}}
                    </v-chip>
                    </div>
                    <div>
                     <v-chip
                      x-small
                      :color="hasPPMPStatus('NON-DBM') == 'Published' ? 'header' : 'warning'"
                      text-color="white"
                      v-if="formData.PPMPBudgetCode"
                    >
                      {{hasPPMPStatus('NON-DBM')}}
                    </v-chip>
                    </div>
                    </div>
                    </v-col>
                  </v-row>
                </v-card>
                </v-col>

                <!-- PR Number -->
                <v-col cols="12" md="6">
                  <div class="d-flex align-center">
                    <v-checkbox
                      v-model="formData.UsePR"
                      hide-details
                      class="mr-2 mb-3 pt-0"
                      color="header"
                      label="Include PR Number"
                    ></v-checkbox>
                  </div>
                    <v-autocomplete
                      v-if="formData.UsePR"
                      v-model="formData.PRNumber"
                      @change="changePRCode()"
                      outlined
                      dense
                      color="header"
                      label="PR Number"
                      :items="prList"
                      item-text="PRCODE"
                      item-value="PRID"
                      :rules="[formRules.required]"
                      hide-details
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else
                      outlined
                      dense
                      color="header"
                      label="PR Number"
                      :disabled="true"
                      hide-details
                    ></v-autocomplete>

                  <v-card v-if="prItems.length > 0" class="mt-2" outlined height="220">
                  <v-card-title class="text-subtitle-1 py-1">
                      Deletable Items
                      <v-spacer></v-spacer>
                      <v-checkbox v-model="selectAllItems" v-if="prItems.length > 1" small color="header" label="Select All" class="ma-0 pa-0" hide-details></v-checkbox>
                  </v-card-title>

                  <v-divider></v-divider>

                  <div style="height: 160px; overflow-y: auto;">
                    <v-list dense>
                      <v-list-item
                        v-for="item in prItems"
                        :key="item.ppmpItemID"
                      >
                        <v-list-item-action class="mr-3">
                          <v-checkbox
                            v-model="selectedItems"
                            color="header"
                            :value="item"
                            hide-details
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ item.ItemName }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.ItemDescription }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
              </v-card>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex my-5"><v-divider class="mt-3"></v-divider><b class="text-title">TYPE OF REQUEST</b><v-divider class="mt-3"></v-divider></div>
                  <v-checkbox
                      label="Request for revocation/withdrawal of approved Purchased Request (PR)"
                      v-model="formData.PRRevocation"
                      color="header"
                      class="ma-0 pa-0 mb-2"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      label="Request for additional description"
                      v-model="formData.AdditionalDescription"
                      color="header"
                      class="ma-0 pa-0 mb-2"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      label="Others (Please specify)"
                      v-model="formData.Others"
                      color="header"
                      class="ma-0 pa-0 mb-2"
                      hide-details
                    ></v-checkbox>
                    <v-textarea
                      v-if="formData.Others"
                      dense
                      v-model="formData.OtherDescription"
                      color="header"
                      :rules="[formRules.required]"
                      outlined
                      rows="2"
                      label="">
                    </v-textarea>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="text-subtitle-2 mb-2">
                    Reason <i>(Please specify)</i>
                  </div>
                  <v-textarea
                    dense
                    v-model="formData.Reason"
                    color="header"
                    :rules="[formRules.required]"
                    outlined
                    label="">
                  </v-textarea>
              </v-col>
              </v-row>
              </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                outlined
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn
              v-if="editItemId"
                color="blue darken-2"
                class="white--text"
                @click="update"
                :loading="isLoading"
              >
              <v-icon class="mr-1">mdi-square-edit-outline</v-icon>
                Update
              </v-btn>
              <v-btn
                color="green darken-2"
                class="white--text"
                @click="submit"
                :loading="isLoading"
              >
              <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogConfirm" max-width="500px">
          <v-card>
            <v-card-title class="headline">Confirmation</v-card-title>
            <div class="mx-6">
              <strong>Are you sure you want to submit this request?</strong>
            </div>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" outlined @click="dialogConfirm = false">Cancel</v-btn>
              <v-btn color="green darken-2 white--text" @click="confirmSubmit()">Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <ViewRequest :requestData="viewData" />
      <fade-away-message-component
			displayType="variation2"
			v-model="fadeAwayMessage.show" 
			:message="fadeAwayMessage.message" 
			:header="fadeAwayMessage.header" 
			:top="fadeAwayMessage.top"
			:type="fadeAwayMessage.type"
		></fade-away-message-component>
  </div>
</template>

<script>
import MyCompletedRequests from './MyCompletedRequests.vue'
import ViewRequest from './ViewRequest.vue'
  export default {
    components: {
      MyCompletedRequests,
      ViewRequest
    },
    data: () => ({
      searchText: "",
      searchTimeout : null,
      amountErr: null,
      amountErr2: null,
      editItemId: null,
       footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
      totalCount: 0,
      loading: true,
       options: {},
      fadeAwayMessage : {
			show : false,
			type : 'success',
			header : 'Successfully Saved!',
			message : '',
			top : 10
		},
      isLoading: false,
      menu: false,
      menu1: false,
      formData: {
        RequestType: null,
        UsePPMP: false,
        PPMPType: [],
        PPMPBudgetCode: '',
        UsePR: false,
        PRNumber: '',
        PRRevocation: false,
        AdditionalDescription: false,
        Others: false,
        OtherDescription: null,
        Reason: null,
      },
      requestDialog: false,
      pendingList: [],
      requestTypes: [],
      headers: [
        { text: 'Request Code', value: 'RequestCode', sortable: false, align: 'start', class: "green darken-2 white--text text-caption font-weight-bold" },
        {
          text: 'Request Type',
          align: 'start',
          sortable: false,
          value: 'RequestType',
          class: "green darken-2 white--text text-caption font-weight-bold",
        },
        // { text: 'Office', value: 'Office', align: "start", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        // { text: 'Requested By', value: 'RequestedBy', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Date Created', value: 'DateCreated', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Status', value: 'Status', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Date Approved', value: 'DateApproved', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Actions', value: 'Actions', align: "center", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" }
      ],
      itemListForCSV: [],
      loadingCSV: true,
      viewData: [],
      items: [],
      selectedItems: [],
      budgetList: [],
      prList: [],
      ppmpDetails: [],
      prItems: [],
      selectAllItems: false,
      dialogConfirm: false,
    }),
    watch: {
      options: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
      selectAllItems: {
        handler (data) {
         if(data){
          this.selectedItems = this.prItems
         }
         else{
          this.selectedItems = [];
         }
        },
        deep: true,
      },
      searchText : function(){
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
			this.initialize();
			}, 600);
		},
    'formData.UsePPMP': {
        handler(value) {
          if (!value) {
            this.formData.PPMPBudgetCode = null;
          }
        },
        immediate: true
      },
      'formData.UsePR': {
        handler(value) {
          if (!value) {
            this.formData.PRNumber = null;
            this.prItems = [];
            this.selectedItems = [];
            this.selectAllItems = false;
          }
        },
        immediate: true
      }
    },
    created() {
      this.getRequestTypes();
    },  
    mounted () {
      this.eventHub.$on("closeViewRequest", () => {
        this.initialize();
      });
        this.initialize();

    },
    beforeDestroy() {
      this.eventHub.$off("closeViewRequest");
    },
    methods: {
      createRequest(){
        this.requestDialog = true;
      },
      changeRequest(){
        let data = new FormData();
        data.append("type", this.formData.RequestType)
        this.axiosCall(
            '/request/details',
            'POST',
            data
        )
        .then((res) => {
          if(res.data.status){
            this.budgetList = res.data.data.budgetList;
            this.prList = res.data.data.prList;
          }
        })
      },
      changeBudgetCode(){
          let data = new FormData();
          data.append("PPMPIDs", this.formData.PPMPBudgetCode)
          this.axiosCall(
              '/request/details/ppmp',
              'POST',
              data
          )
          .then((res) => {
            if(res.data.status){
              console.log(this.formData.PPMPType)
              this.formData.PPMPType = [];
              this.ppmpDetails = res.data.data
            }
          })
      },
      changePRCode(){
          let data = new FormData();
          data.append("PRID", this.formData.PRNumber)
          this.axiosCall(
              '/request/details/pr',
              'POST',
              data
          )
          .then((res) => {
            if(res.data.status){
              this.selectedItems = [];
              this.prItems = res.data.data
            }
          })
      },
      hasPPMPStatus(type) {
        return this.ppmpDetails.find(x => x.Type == type)?.PPMPStatusID == 12 ? 'Published' : this.ppmpDetails.find(x => x.Type == type)?.PPMPStatusID == 12 ? 'Unpublished' : 'Not found';
      },
      print(data) {
        window.open(this.apiUrl + "/request/report/" + data.RequestCode);
      },
      viewItem(data){
        this.viewData = data;
      },
      getRequestTypes() {
      this.axiosCall(
              '/request/getTypes',
              'GET'
          )
          .then((res) => {
            if(res.data.status){
              this.requestTypes = res.data.data
              this.requestTypes.forEach(item => {
                item.Description = item.Description + (item.IsActive == 0 ? ' (Not Available)' : '');
              });
            }
          })
		},
      cancel() {
        this.editItemId = null;
        this.transferItemId = null;
        this.$refs.formRef.reset();
        this.requestDialog = false;
        this.request = false;
      },
      initialize() {
        this.loading = true;
        this.loadingCSV = true;
         let data = new FormData();
         if(this.options.page){
              data.append('page', this.options.page);
              data.append('itemsPerPage', this.options.itemsPerPage);
         }else{
              data.append('page', 1);
              data.append('itemsPerPage', 10);
         }
          data.append('searchText', this.searchText);
              this.axiosCall(
              '/request/getPending',
              'POST',
              data
          )
          .then((res) => {
            this.loading = false;
            this.loadingCSV = false;
              this.pendingList = res.data.data.result;
              this.itemListForCSV = res.data.data.result;
              this.itemListForCSV.forEach(item => {
                item.StatusText = item.StatusID == 7 ? "Approved & For Action" : "For Approval";
              });
              this.totalCount = res.data.data.total;
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
          })
      },
      submit(){
        if(this.$refs.formRef.validate() && (this.formData.UsePPMP || this.formData.UsePR)){
        this.dialogConfirm = true;
        }
        else if(!this.formData.UsePPMP && !this.formData.UsePR){
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = 'error';
          this.fadeAwayMessage.message = 'Including either PPMP Budget Code or PR Number in the request is required.';
          this.fadeAwayMessage.header = 'System Message';
        }
      },
      confirmSubmit() {
         if(this.$refs.formRef.validate() && (this.formData.UsePPMP || this.formData.UsePR)){
          this.isLoading = true;
          let data = new FormData();
          data.append('RequestTypeID', this.formData.RequestType);
          data.append('BudgetCode', this.formData.UsePPMP ? this.budgetList.find(u => u.PPMPIDs == this.formData.PPMPBudgetCode).BudgetCode : '');
          data.append('PRCode', this.formData.UsePR ? this.prList.find(u => u.PRID == this.formData.PRNumber).PRCODE : '');
          data.append('PPMPType', this.formData.UsePPMP ? (this.formData.PPMPType).join(',') : '');
          data.append('PRRevocation', this.formData.PRRevocation ? 1 : 0);
          data.append('AdditionalDescription', this.formData.AdditionalDescription ? 1 : 0);
          data.append('Others', this.formData.Others ? 1 : 0);
          data.append('OtherDescription', this.formData.OtherDescription || '');
          data.append('Reason', this.formData.Reason || '');
          data.append('Items', JSON.stringify(this.selectedItems));
                      this.axiosCall(
                    '/request/submit',
                    'POST',
                    data
                )
                .then((res) => {
                    this.isLoading = false;
                    this.dialogConfirm = false;
                    if(res.data.status) {
                    this.fadeAwayMessage.show = true;
                    this.fadeAwayMessage.type = 'success';
                    this.fadeAwayMessage.message = 'Request was successfully submitted!';
                    this.fadeAwayMessage.header = 'System Message';
                    this.cancel();
                    this.initialize();
                    }else {
                    this.fadeAwayMessage.show = true;
                    this.fadeAwayMessage.type = 'error';
                    this.fadeAwayMessage.message = 'Something went wrong try again!';
                    this.fadeAwayMessage.header = 'System Message';
                    }
                })
         }
      },
    }
  }
</script>
<style scoped>
.mei-title {
  color: #777 !important;
}
.mei-pending-title {
  color: #999 !important;
}
</style>